import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  style: {
    "text-align": "center"
  }
};
const _hoisted_2 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_divider = _resolveComponent("van-divider");
  const _component_van_image = _resolveComponent("van-image");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_PageNavBackLayoutCpt = _resolveComponent("PageNavBackLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavBackLayoutCpt, null, {
    default: _withCtx(() => [_createVNode(_component_van_divider), _createElementVNode("div", _hoisted_1, [_createVNode(_component_van_image, {
      height: "64",
      width: "64",
      src: $options.getFileUrl($data.attachment || {})
    }, null, 8, ["src"]), _createElementVNode("div", null, _toDisplayString($data.agent.agentName), 1)]), _createVNode(_component_van_divider), _createVNode(_component_van_cell_group, null, {
      default: _withCtx(() => [_createVNode(_component_van_cell, {
        title: "电话",
        icon: "phone-o",
        "is-link": "",
        "arrow-direction": ""
      }, {
        default: _withCtx(() => [_createElementVNode("a", {
          href: `tel:${$data.agent.mobile}`
        }, _toDisplayString($data.agent.mobile), 9, _hoisted_2)]),
        _: 1
      }), _createVNode(_component_van_cell, {
        title: "服务网点",
        icon: "location-o",
        value: $data.store.storeName
      }, null, 8, ["value"])]),
      _: 1
    })]),
    _: 1
  });
}